import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';
import csrfToken from '../../shared/meta';

configure({ axios });

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

export default function useGetAllFeatureable(wireId) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `/api/v1/wire/${wireId}/featureable`,
    method: 'GET',
  }, { manual: true });
}

export function usePostFeatureableAssignments(wireId, payload) {
  return useAxios(
    {
      url: `/api/v1/wire/${wireId}/featureable`,
      method: 'POST',
      data: payload,
      headers,
    },
    { manual: true },
  );
}
